import { graphqlClient } from "../../../client";
import getDealersForLocatorQueryDocument from "./getDealersForLocatorQuery.graphql";
import type { OrganizationConnection, QueryDealersForLocatorArgs, Query } from "@/core/api/graphql/types";

export async function getDealersForLocator(payload?: QueryDealersForLocatorArgs): Promise<OrganizationConnection> {
  const { data } = await graphqlClient.query<Required<Pick<Query, "dealersForLocator">>, QueryDealersForLocatorArgs>({
    query: getDealersForLocatorQueryDocument,
    variables: {
      ...payload,
    },
  });
  return data.dealersForLocator!;
}
